import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { useTranslation } from 'react-i18next';
import path from 'path-browserify';

import { Link as MuiLink } from '@material-ui/core';

const Link = React.forwardRef(({ to, hasLangPrefix = false, ...props }, ref) => {
  const { i18n } = useTranslation();

  // when switching langage, definitive path is given
  const i18nTo = hasLangPrefix
    ? to
    : path.join(`/${i18n.language}`, to);

  return (
    <MuiLink
      color="secondary"
      component={GatsbyLink}
      innerRef={ref}
      to={i18nTo}
      {...props}
    />
  );
});

Link.displayName = 'LocalizedLink';

export default Link;
